import { render, staticRenderFns } from "./PriceConfig.vue?vue&type=template&id=8ad2a59a&scoped=true"
import script from "./PriceConfig.vue?vue&type=script&lang=js"
export * from "./PriceConfig.vue?vue&type=script&lang=js"
import style0 from "./PriceConfig.vue?vue&type=style&index=0&id=8ad2a59a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad2a59a",
  null
  
)

export default component.exports